import { UnderlinedTextButton } from "@/components/button/underlined-text-button";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";

interface AlternativePlanErrorProps {
  retry: () => void;
}

export const AlternativePlanError = ({ retry }: AlternativePlanErrorProps) => {
  return (
    <div className={cn("flex h-full w-full flex-col items-center gap-4 px-8 py-17 text-center")}>
      <h1 className={cn(textVariants.headline, "uppercase")}>
        Sorry, I can’t find
        <br /> suitable meals for you
      </h1>
      <UnderlinedTextButton
        onClick={retry}
        className={cn(textVariants.title3, "text-screen-gs-1 leading-11")}
      >
        Retry
      </UnderlinedTextButton>
    </div>
  );
};
